export const MODIFICATION_QUANTITY_LABEL = 'sur cette page';
export const PAGE_HISTORY_TITLE = 'Historique des modifications de la page';
